<app-info-page title="Device pool" [showNav]="false">
  <div [ngClass]="isMobile() ? 'devices-mobile-wrapper' : 'devices-wrapper'">
    <div class="filter-container" [class.mb-m]="!isMobile()" [class.phone-toolbar]="isMobile()">
      <div class="flex-col" [class.filter-row]="isMobile()">
        <button class="hover-button margin-right-xs"
          [class.no-padding-left]="!isMobile()" [matMenuTriggerFor]="filter" mat-button>
          <div style="float: left">
            <svg-icon
              [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              class="icon-hover pr-xs black-icon"
              src="{{ displayedFilter.icon }}"
            ></svg-icon>
            {{ displayedFilter.label }}
          </div>
        </button>
      </div>

      <mat-menu #filter="matMenu">
        @for (type of deviceTypes; track type) {
        <ng-container matMenuContent>
          <button mat-menu-item class="button-size" (click)="setDeviceTypeControl(type)">
            <svg-icon
              [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              class="icon-hover pr-xs black-icon"
              src="{{ type.icon }}"
            ></svg-icon>
            {{ type.label }}
          </button>
        </ng-container>
        }
      </mat-menu>

      <app-search-field
        class="search-field"
        (keyUp)="setSearchControl($event)"
        [placeHolder]="'component.OVERVIEW.FORM-FIELD.PLACE_HOLDER' | translate"
        #searchcontrol
      ></app-search-field>
    </div>
    <mat-card class="shadow-card">
      <ng-container>
        @if (!isLoaded) {
        <div class="spinner-wrapper">
          <mat-spinner></mat-spinner>
        </div>
        }

        <div [ngClass]="{ 'pl-l pt-l': !isMobile(), 'p-s': isMobile() }" id="devices-list-table-wrapper">
          <app-table
            id="devices-table"
            [hidden]="!isLoaded"
            [tableCols]="displayedColumns"
            phoneLayout="rows"
            [dataSource]="devices"
            [pageSize]="pageSize"
            [totalItems]="totalItemCount"
            [infiniteScrollOnPhone]="true"
            [selectedPageIndex]="pageNumber"
            [showSum]="true"
            sumLabel="SHARED.TABLE.TOTAL"
            (sortingChanged)="setSorting($event)"
            (paginationChanged)="handlePaginationEvent($event)"
            (linkClicked)="openDeviceConfigurationDialog($event)"
          >
          </app-table>
        </div>
      </ng-container>
    </mat-card>
  </div>
</app-info-page>
